import gql from 'graphql-tag'

export const FETCH_EMAIL_DATA = gql`
query fetchEmail($emailFilter: String!, $fetchFrom: fetchFromEnum!, $account: accountEnum, $offset: Int, $limit: Int){
    fetchEmail(data: { offset: $offset, limit: $limit, emailFilter: $emailFilter, fetchFrom: $fetchFrom, account: $account }){
      result
    }
  }
`

export const FETCH_EMAIL_BY_ID = gql`
  query fetchEmailById($messageId: String!, $fetchFrom: fetchFromEnum!, $account: accountEnum){
    fetchEmailById(data: { messageId: $messageId, fetchFrom: $fetchFrom, account: $account }){
      result
    }
  }
`

